<template>
    <div
        class="h-auto mx-auto flex"
        style="background-color: #FBFBFB"
    >
        <div class="w-full max-w-7xl mx-auto py-20 flex">
            <div class="w-1/3 ml-10 2xl:ml-0">
                <h1
                    v-for="program in programs"
                    class="font-semibold mr-6 text-4xl my-14"
                >
                    {{ program.title }}
                </h1>
            </div>
            <div class="w-2/3 mx-auto flex flex-col">
                <div class="mt-7 py-3 mr-20 2xl:mr-0">
                    <Accordion
                        v-for="day in days"
                        class="my-3"
                    >
                        <template #title>
                            <span class="text-xl mb-3">{{ day.day }}</span>
                        </template>
                        <template #content>
                            <div
                                v-for="time in day.times"
                                class="my-8"
                            >
                                <p class="mt-2 flex items-center text-gray-500">
                                    <svg
                                        width="12"
                                        height="12"
                                        class="mr-2"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M6 3.66667V6L7.75 7.75M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6Z"
                                            stroke="#01798A"
                                            stroke-width="1.16667"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    {{ time.time }}
                                </p>
                                <p class="text-lg">
                                    <strong>{{ time.headline }}</strong>
                                </p>
                                <EditableProposalText :text="time.text" :star="true"/>
                            </div>
                        </template>
                    </Accordion>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Accordion from '@/ComponentsDeprecated/Accordion/Accordion';
import EditableProposalText from "@/ComponentsDeprecated/Proposal/EditableProposalText";

const programs = [
    {
        title: 'Program for høstreise 2023',
    },

];

const days = [
    {
        day: 'Fredag',
        times: [
            {
                time: '12:00 - 12:15',
                headline: 'Ankomst Nice Lufthavn',
                text: 'I ankomsthallen blir vi møtt av lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            },
            {
                time: '12:30 - 14:45',
                headline: 'Innsjekk hotell',
                text: 'Innsjekk av lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            },
            {
                time: '15:00 - 20:00',
                headline: 'Middag med underholdning',
                text: 'I løpet av middagen blir vi underholdt av lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
            },
        ],
    },
    {
        day: 'Lørdag',
        times: [
            {
                time: '12:00 - 17:00',
                headline: 'Middag på the ritz',
                text: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        ],
    },
    {
        day: 'Søndag',
        times: [
            {
                time: '17:00 - 17:15',
                headline: 'Avreise Monte Carlo',
                text: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        ],
    },
];
</script>
